import { useEffect } from 'react';
import { HashRouter, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import WorkDetail from './pages/WorkDetail';
import SplashCursor from './components/SplashCursor';
import ChatBot from './components/ChatBot';
import './App.css';
import AIPage from './sections/aipage.jsx';
import ArticlePage from './sections/ArticlePage';
import Demo from './pages/Demo';
import GrowthPage from './pages/GrowthPage';
import IntelligencePage from './pages/IntelligencePage';
import AurelixAIPage from './pages/AurelixAIPage';

/* ── Scroll to top on every route change ── */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function ContactPage() {
  useEffect(() => {
    const timer = setTimeout(() => {
      document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
    }, 150);
    return () => clearTimeout(timer);
  }, []);
  return <Home />;
}

export default function App() {
  /* ── Global scroll-highlight observer ── */
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('hl-on');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );
    // observe existing elements; re-scan on route changes via a short delay
    const scan = () =>
      document.querySelectorAll('.scroll-hl').forEach((el) => obs.observe(el));
    scan();
    const t = setTimeout(scan, 600);
    return () => { clearTimeout(t); obs.disconnect(); };
  }, []);
  return (
    <HashRouter>
        <ScrollToTop />
        <SplashCursor
          SIM_RESOLUTION={64}
          DYE_RESOLUTION={512}
          DENSITY_DISSIPATION={3.5}
          VELOCITY_DISSIPATION={0.5}
          PRESSURE={0}
          PRESSURE_ITERATIONS={10}
          CURL={3}
          SPLAT_RADIUS={0.01}
          SPLAT_FORCE={2500}
          COLOR_UPDATE_SPEED={3}
          SHADING={false}
          RAINBOW_MODE={false}
          COLOR="#ffffff"
        />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/ai" element={<AIPage />} />
          <Route path="/growth" element={<GrowthPage />} />
          <Route path="/intelligence" element={<IntelligencePage />} />
          <Route path="/aurelix-ai" element={<AurelixAIPage />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/news/:id" element={<ArticlePage />} />
        </Routes>
        <ChatBot />
    </HashRouter>
  );
}